import { Injectable } from '@angular/core';
import { AccessLog, DefaultService } from '@psnb/psnb-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccessLogService {
  constructor(private powerSupplyService: DefaultService) {
  }

  public getAllAccessLogs(days: number, search: string): Observable<AccessLog[]> {
    return this.powerSupplyService.getAccessLogs(days, search)
      .pipe(map((result: AccessLog[]): AccessLog[] => result));
  }

  public createAccessLog(accessLog: AccessLog) {
    return this.powerSupplyService.createAccessLog(accessLog)
      .pipe(map(result => result));
  }

  public updateAccessLog(accessLog: AccessLog) {
    return this.powerSupplyService.updateAccessLog(accessLog)
      .pipe(map(result => result));
  }

  public deleteAccessLog(id: number) {
    return this.powerSupplyService.deleteAccessLog(id)
      .pipe(map(result => result));
  }
}
